var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.59525,
    y: 19.4048,
    width: 16.8095,
    height: 4.2381,
    rx: 2.11905,
    transform: "rotate(-90 1.59525 19.4048)",
    stroke: "#C8CCD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.88095,
    y: 19.4048,
    width: 16.8095,
    height: 4.2381,
    rx: 2.11905,
    transform: "rotate(-90 8.88095 19.4048)",
    stroke: "#C8CCD8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1667,
    y: 19.4048,
    width: 16.8095,
    height: 4.2381,
    rx: 2.11905,
    transform: "rotate(-90 16.1667 19.4048)",
    stroke: "#C8CCD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphcard);
export default __webpack_public_path__ + "static/media/graphcard.2aed5bb33c1d1fd3aa8b1f383b27be8d.svg";
export { ForwardRef as ReactComponent };